import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--obsidian)] text-[var(--bone)] mt-32">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/brand/fundle-logo.png" alt="Fundle" className="h-10 w-auto invert" />
              <span className="text-[10px] tracking-[0.3em] uppercase font-semibold text-[var(--gold)] border-l border-white/15 pl-3">
                Space&nbsp;on&nbsp;Hiring
              </span>
            </div>
            <p className="mt-7 font-serif text-2xl lg:text-3xl leading-[1.15] text-[var(--bone)] max-w-md">
              India&apos;s mall advertising &amp; retail-media marketplace —
              <span className="font-serif-italic text-[var(--gold-light)]"> editorial-grade, AI-powered.</span>
            </p>
            <Link
              to="/contact"
              className="mt-9 inline-flex items-center gap-3 text-[12px] uppercase tracking-[0.2em] font-semibold text-[var(--bone)] hover:text-[var(--gold)] transition-colors"
              data-testid="footer-cta"
            >
              <span className="gold-rule" /> Start a campaign <ArrowUpRight size={14} />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10">
            <FCol title="Platform" items={[
              { t: "Marketplace", to: "/marketplace" },
              { t: "AI Planner", to: "/ai-planner" },
              { t: "Solutions", to: "/solutions" },
              { t: "Work", to: "/case-studies" },
            ]} />
            <FCol title="Discover" items={[
              { t: "Cities", to: "/cities" },
              { t: "Industries", to: "/industries" },
              { t: "Insights", to: "/resources" },
              { t: "Admin", to: "/admin/login" },
            ]} />
            <FCol title="Contact" items={[
              { t: "partners@fundle.in" },
              { t: "Mumbai · Delhi · Bengaluru" },
              { t: "Mon – Sat · 09:30 – 19:00 IST" },
            ]} />
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-[11px] uppercase tracking-[0.22em] text-white/50">
            © {new Date().getFullYear()} Fundle · SOH. All rights reserved.
          </div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-mono">
            Built for India&apos;s retail-media decade
          </div>
        </div>
      </div>
    </footer>
  );
}

function FCol({ title, items }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">{title}</div>
      <ul className="mt-5 space-y-2.5 text-sm text-white/80">
        {items.map((i, idx) => (
          <li key={idx}>
            {i.to ? (
              <Link to={i.to} className="hover:text-[var(--gold-light)] transition-colors">{i.t}</Link>
            ) : (
              <span>{i.t}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
